module.exports = __webpack_public_path__ + "f55f203c969a008e76cfcaa52dea4ea0.png";